import React from "react";

// Default components
import {defaultComponents} from "./../components/_default/interfaces/DefaultComponents"
import ContentRenderer from "./../components/_default/ContentRenderer"
import MetadataComponent from "./../components/_default/MetadataComponent";
import CheckNotFoundPage from "./../components/_default/CheckNotFoundPage";
import { useAppSelector, useAppDispatch } from "./../store/hooks"

window.defaultComponents = defaultComponents;

export default function Webpage2Lehte_ei_leitud() {
        const page_seo = {
                    seo_title: 'Lehte ei leitud - madlivali.ee',
                    canonical: 'https:\/\/madlivali.ee\/et\/*',
            }
    
    const dispatch = useAppDispatch();
    
    React.useEffect(() => {
        dispatch({
            type: "SET_WEBPAGE_ACTIVE",
            payload: "019c93cb-cab9-7b32-aa96-9713d53182c7"
        });
    }, [])
    
    React.useEffect(() => {
        dispatch({
            type: "UPDATE_STRUCTURE",
            payload: {"webpageComponents":[220],"components":{"220":{"id":220,"uuid":"019e8707-9860-7fc9-a479-7e3389d4f660","language_id":null,"parent_id":null,"webpage_id":2,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"row","content_width_unit":"px","content_width_size":600,"styles":{"paddingTop":"60px","paddingLeft":"20px","paddingRight":"20px","paddingBottom":"60px","marginLeft":"0px","marginRight":"0px","marginBottom":"0px","marginTop":"0px"}},"childWebpageComponentRelations":[{"id":216,"parent_id":220,"child_id":239,"sort":0,"created_at":null,"updated_at":"2026-06-02T06:38:04.000000Z"}]},"239":{"id":239,"uuid":"019e8707-9860-7fc9-a479-7e338a83773b","language_id":1,"parent_id":220,"webpage_id":2,"type":"section","sort_order":0,"version":1,"isShared":false,"attributes":{"classes":"col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12","styles":{"paddingTop":"20px","paddingLeft":"0px","paddingBottom":"20px","paddingRight":"0px","marginLeft":"0px","marginRight":"0px","marginBottom":"0px","marginTop":"0px"}},"childWebpageComponentRelations":[{"id":217,"parent_id":239,"child_id":240,"sort":0,"created_at":null,"updated_at":"2026-06-02T06:38:04.000000Z"}]},"240":{"id":240,"uuid":"019e8707-9860-7fc9-a479-7e338ae24c5d","language_id":1,"parent_id":239,"webpage_id":2,"type":"text","sort_order":0,"version":1,"isShared":false,"attributes":{"text":"\u003Cp style=\u0022text-align: center\u0022\u003E\u003Cspan style=\u0022font-size: 30px\u0022\u003E404 Lehte ei leitud\u003C\/span\u003E\u003C\/p\u003E","typography_id":1,"styles":{"paddingTop":"0px","paddingBottom":"0px","paddingLeft":"0px","paddingRight":"0px","marginTop":"0px","marginBottom":"0px"}},"childWebpageComponentRelations":[]}}}        });
    }, [])
    
    
    
    return (
        <>
            <CheckNotFoundPage/>
            <MetadataComponent page_seo={page_seo} />
            <ContentRenderer />
        </>
    );
}